(() => {
  // Supprime une contenance en fin de texte : " - 100ml", "100 ml", "0.1L", etc.
  const VOLUME_END_RE = /\s*(?:[-–—]\s*)?\d+(?:[.,]\d+)?\s*(?:ml|cl|l)\b\s*$/i;

  const cleanNode = (el) => {
    if (!el || el.children.length > 0) return; // sécurité: on ne touche qu'aux noeuds texte simples

    const original = el.textContent || "";
    const cleaned = original.replace(VOLUME_END_RE, "").trim();

    if (cleaned !== original) el.textContent = cleaned;
  };

  const run = (root = document) => {
    // Mini-panier / drawer (ton code montre .ajaxcart__product-meta .property-value)
    root.querySelectorAll(".ajaxcart__product-meta .property-value").forEach(cleanNode);

    // Panier page (selon thème, on tente quelques sélecteurs courants)
    root.querySelectorAll(
      ".cart__product-meta .property-value, .cart__meta-text .property-value, .cart__item--properties .property-value"
    ).forEach(cleanNode);
  };

  // 1) au chargement
  document.addEventListener("DOMContentLoaded", () => run(document));

  // 2) pour les mini-paniers rendus dynamiquement (Vue/React/Ajax)
  const obs = new MutationObserver((mutations) => {
    for (const m of mutations) {
      for (const node of m.addedNodes) {
        if (node.nodeType === 1) run(node);
      }
    }
  });

  obs.observe(document.documentElement, { childList: true, subtree: true });
})();